import ML_Intro from "./components/ML_Intro.jsx";
import ML_AI from "./components/ML_AI.jsx";
import ML_Languages from "./components/ML_Languages.jsx";
import ML_JavaScript from "./components/ML_JavaScript.jsx";
import ML_Examples from "./components/ML_Examples.jsx";
import ML_Linear_Graphs from "./components/ML_Linear_Graphs.jsx";
import ML_Scatter_Plots from "./components/ML_Scatter_Plots.jsx";
import ML_Perceptrons from "./components/ML_Perceptrons.jsx";
import ML_Recognition from "./components/ML_Recognition.jsx";
import ML_Training from "./components/ML_Training.jsx";
import ML_Testing from "./components/ML_Testing.jsx";
import ML_Learning from "./components/ML_Learning.jsx";
import ML_Terminology from "./components/ML_Terminology.jsx";
import ML_Data from "./components/ML_Data.jsx";
import ML_Clustering from "./components/ML_Clustering.jsx";
import ML_Regressions from "./components/ML_Regressions.jsx";
import ML_Deep_Learning from "./components/ML_Deep_Learning.jsx";
import ML_BrainJS from "./components/ML_BrainJS.jsx";
import TFJS_Tutorial from "./components/TFJS_Tutorial.jsx";
import TFJS_Operations from "./components/TFJS_Operations.jsx";
import TFJS_Models from "./components/TFJS_Models.jsx";
import TFJS_Visor from "./components/TFJS_Visor.jsx";
import Ex1_Intro from "./components/Ex1_Intro.jsx";
import Ex1_Data from "./components/Ex1_Data.jsx";
import Ex1_Model from "./components/Ex1_Model.jsx";
import Ex1_Training from "./components/Ex1_Training.jsx";
import Ex2_Intro from "./components/Ex2_Intro.jsx";
import Ex2_Data from "./components/Ex2_Data.jsx";
import Ex2_Model from "./components/Ex2_Model.jsx";
import Ex2_Training from "./components/Ex2_Training.jsx";
import Graph_Intro from "./components/Graph_Intro.jsx";
import Graph_Canvas from "./components/Graph_Canvas.jsx";
import Graph_Plotly from "./components/Graph_Plotly.jsx";
import Graph_ChartJS from "./components/Graph_ChartJS.jsx";
import Graph_Google from "./components/Graph_Google.jsx";
import Graph_D3 from "./components/Graph_D3.jsx";
import History_Intelligence from "./components/History_Intelligence.jsx";
import History_Languages from "./components/History_Languages.jsx";
import History_Numbers from "./components/History_Numbers.jsx";
import History_Computing from "./components/History_Computing.jsx";
import History_Robots from "./components/History_Robots.jsx";
import History_AI from "./components/History_AI.jsx";
import History_Jobs from "./components/History_Jobs.jsx";
import History_TheoryOfMind from "./components/History_TheoryOfMind.jsx";
import Math from "./components/Math.jsx";
import Math_LinearFunctions from "./components/Math_LinearFunctions.jsx";
import Math_LinearAlgebra from "./components/Math_LinearAlgebra.jsx";
import Math_Vectors from "./components/Math_Vectors.jsx";
import Math_Matrices from "./components/Math_Matrices.jsx";
import Math_Tensors from "./components/Math_Tensors.jsx";
import Statistics from "./components/Statistics.jsx";
import Statistics_Descriptive from "./components/Statistics_Descriptive.jsx";
import Statistics_Variability from "./components/Statistics_Variability.jsx";
import Statistics_Distribution from "./components/Statistics_Distribution.jsx";
import Statistics_Probability from "./components/Statistics_Probability.jsx";

const machinelearningComponentsMap = {
  "<ML_Intro />": ML_Intro,
  "<ML_AI />": ML_AI,
  "<ML_Languages />": ML_Languages,
  "<ML_JavaScript />": ML_JavaScript,
  "<ML_Examples />": ML_Examples,
  "<ML_Linear_Graphs />": ML_Linear_Graphs,
  "<ML_Scatter_Plots />": ML_Scatter_Plots,
  "<ML_Perceptrons />": ML_Perceptrons,
  "<ML_Recognition />": ML_Recognition,
  "<ML_Training />": ML_Training,
  "<ML_Testing />": ML_Testing,
  "<ML_Learning />": ML_Learning,
  "<ML_Terminology />": ML_Terminology,
  "<ML_Data />": ML_Data,
  "<ML_Clustering />": ML_Clustering,
  "<ML_Regressions />": ML_Regressions,
  "<ML_Deep_Learning />": ML_Deep_Learning,
  "<ML_BrainJS />": ML_BrainJS,
  "<TFJS_Tutorial />": TFJS_Tutorial,
  "<TFJS_Operations />": TFJS_Operations,
  "<TFJS_Models />": TFJS_Models,
  "<TFJS_Visor />": TFJS_Visor,
  "<Ex1_Intro />": Ex1_Intro,
  "<Ex1_Data />": Ex1_Data,
  "<Ex1_Model />": Ex1_Model,
  "<Ex1_Training />": Ex1_Training,
  "<Ex2_Intro />": Ex2_Intro,
  "<Ex2_Data />": Ex2_Data,
  "<Ex2_Model />": Ex2_Model,
  "<Ex2_Training />": Ex2_Training,
  "<Graph_Intro />": Graph_Intro,
  "<Graph_Canvas />": Graph_Canvas,
  "<Graph_Plotly />": Graph_Plotly,
  "<Graph_ChartJS />": Graph_ChartJS,
  "<Graph_Google />": Graph_Google,
  "<Graph_D3 />": Graph_D3,
  "<History_Intelligence />": History_Intelligence,
  "<History_Languages />": History_Languages,
  "<History_Numbers />": History_Numbers,
  "<History_Computing />": History_Computing,
  "<History_Robots />": History_Robots,
  "<History_AI />": History_AI,
  "<History_Jobs />": History_Jobs,
  "<History_TheoryOfMind />": History_TheoryOfMind,
  "<Math />": Math,
  "<Math_LinearFunctions />": Math_LinearFunctions,
  "<Math_LinearAlgebra />": Math_LinearAlgebra,
  "<Math_Vectors />": Math_Vectors,
  "<Math_Matrices />": Math_Matrices,
  "<Math_Tensors />": Math_Tensors,
  "<Statistics />": Statistics,
  "<Statistics_Descriptive />": Statistics_Descriptive,
  "<Statistics_Variability />": Statistics_Variability,
  "<Statistics_Distribution />": Statistics_Distribution,
  "<Statistics_Probability />": Statistics_Probability,
};

export default machinelearningComponentsMap;
